// src/components/quality/view/QualityCAView.jsx
import PeopleView from "../../common/people/PeopleView";
import TableCell from "../../common/ui/TableCell";

export default function QualityCAView({ data }) {
  if (!data) return null;

  const header = data.header || {};
  const car = data.car || {};

  return (
    <div className="space-y-6">

      <table className="w-full border text-sm">
        <colgroup>
          <col style={{ width: "120px" }} />
          <col />
          <col style={{ width: "120px" }} />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <TableCell colSpan={3} label="연결 NCR" value={header.ncr_dns || "-"} />
          </tr>
          <tr>
            <TableCell
              label="책임 담당자"
              colSpan={3}
              value={
                <PeopleView
                  dns={data.doc_dns}
                  // value={meta?.requestPeople || []} 
                  placeholder="지정된 담당자 없음"
                />
              }
            />
          </tr>

          <tr>
            <TableCell colSpan={3} label="중요도" value={header.severity || "-"} />
            {/* <TableCell label="" value="" /> */}
          </tr>
          <tr>
            <TableCell label="조치기한" value={header.due_date || "-"} />
            <TableCell label="종결일" value={header.close_date || "-"} />
          </tr>

        </tbody>
      </table>

      <div>
        <h3 className="font-semibold mt-4 mb-1">근본원인</h3>
        <div className="border p-3 rounded">{car.root_cause || "-"}</div>

        <h3 className="font-semibold mt-4 mb-1">시정조치</h3>
        <div className="border p-3 rounded">{car.corrective_action || "-"}</div>

        <h3 className="font-semibold mt-4 mb-1">예방조치</h3>
        <div className="border p-3 rounded">{car.preventive_action || "-"}</div>

        <h3 className="font-semibold mt-4 mb-1">검증방법/기준</h3>
        <div className="border p-3 rounded">{car.verification || "-"}</div>
      </div>
    </div>
  );
}
